import { useQuery } from "@tanstack/react-query";
import { Award } from "lucide-react";
import { defineModuleUi, from, unwrap, useOrg } from "@vixio/data";
import { Meter, lazyPage } from "@vixio/ui";
import { PERIOD_LABEL, type Goal } from "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const AuthorityPage = lazyPage(() => import("./AuthorityPage"), "AuthorityPage");

function GoalsWidget() {
  const org = useOrg();
  const q = useQuery({
    queryKey: ["authority", "v_goals", org.id],
    queryFn: () => unwrap<Goal[]>(from("authority", "v_goals").select("*").eq("org_id", org.id).eq("active", true).order("key")),
  });
  if (!q.data?.length) return <p className="muted">Nenhuma meta de autoridade.</p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {q.data.slice(0, 5).map((g) => (
        <li key={g.id}>
          <div className="vx-row vx-row--between">
            <span>{g.title}</span>
            <span className="num text-2">
              {g.progress}/{g.target} {PERIOD_LABEL[g.period]}
            </span>
          </div>
          <Meter pct={Math.min(100, Math.round((100 * g.progress) / g.target))} />
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "authority",
  title: "Autoridade",
  domain: "content",
  icon: Award,
  menu: [
    { path: "/conteudo/autoridade", label: "Autoridade", minRole: "member", icon: Award, order: 50, keywords: "linkedin lattes orcid dossiê decisores podcast livro metas" },
  ],
  routes: [{ path: "/conteudo/autoridade", element: <AuthorityPage />, minRole: "member" }],
  widgets: [{ key: "authority-goals", title: "Metas de autoridade", minRole: "member", span: 1, order: 65, element: GoalsWidget }],
});
